import React from 'react';
import SIcon from './SIcon';
import { faChargingStation } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faChargingStation} fa />;

export default Icon;
